import {
  initializeWidgetConfiguration,
  SgWidget,
  WidgetConfigurationProvider,
  WithGlobalCss,
} from "@sgwt-widget/core";
import { h } from "preact";
import { emit, props } from "skatejs";
import WidgetTracker from "../common/components/WidgetTracker/WidgetTracker";
import { TextBoxComponent } from "./components/TextBoxComponent";

interface IProps {
  widgetTextType: string;
  userSelection: { [attribute: string]: string };
}

export class CprSelectTextbox extends SgWidget<IProps> {
  static get is() {
    return "cpr-select-textbox";
  }
  public static props = {
    userSelection: props.object,
    widgetTextType: props.string,
  };
  // tslint:disable-next-line:cognitive-complexity
  public render(intraprops: IProps) {
    const widgetTextType = intraprops.widgetTextType || "";
    const textSelected =
      intraprops.userSelection && intraprops.userSelection.text
        ? intraprops.userSelection.text
        : "";

    const onChange = (value: string) => {
      const newValue =
        value && value.length > 0 ? { ["text"]: value } : { ["text"]: "" };
      intraprops.userSelection = newValue;
      emit(this, "cpr-select-textbox--filter-changed", {
        detail: newValue,
      });
    };

    return (
      <WidgetConfigurationProvider
        widgetConfiguration={this.widgetConfiguration}
      >
        <WithGlobalCss>
          <TextBoxComponent
            onChange={onChange}
            widgetTextType={widgetTextType}
            textValue={textSelected}
          />
          <WidgetTracker widgetName={CprSelectTextbox.is} />
        </WithGlobalCss>
      </WidgetConfigurationProvider>
    );
  }
}

initializeWidgetConfiguration(CprSelectTextbox);
customElements.define(CprSelectTextbox.is, CprSelectTextbox);
